/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';

export interface CheckEmailRequest {
    email: string;
    portalId: number;
}

export interface VerifyOtpRequest {
    id: number;
    email: string;
    otp: number;
    portalId: number;
}

export interface SetPasswordRequest {
    id: number;
    email: string;
    password: string;
    portalId: number;
}

export interface MigrationResponse {
    statusCode: number;
    data: any;
    message?: string;
}

/**
 * Check email and send passcode for migration
 * @param payload - CheckEmailRequest with email and portalId
 * @param showLoader - Whether to show loader
 */
export const checkEmailForMigration = async (
    payload: CheckEmailRequest,
    showLoader: boolean = true,
): Promise<MigrationResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.CheckEmailForMigration,
            showLoader,
            payLoad: payload,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error checking email for migration:', error);
        throw error;
    }
};

/**
 * Verify passcode for migration
 * @param payload - VerifyOtpRequest with id, email, otp, and portalId
 * @param showLoader - Whether to show loader
 */
export const verifyOtpForMigration = async (
    payload: VerifyOtpRequest,
    showLoader: boolean = true,
): Promise<MigrationResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.VerifyOtpForMigration,
            showLoader,
            payLoad: payload,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error verifying passcode for migration:', error);
        throw error;
    }
};

/**
 * Set password for migration
 * @param payload - SetPasswordRequest with id, email, password, and portalId
 * @param showLoader - Whether to show loader
 */
export const setPasswordForMigration = async (
    payload: SetPasswordRequest,
    showLoader: boolean = true,
): Promise<MigrationResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: api_urls.SetPasswordForMigration,
            showLoader,
            payLoad: payload,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error setting password for migration:', error);
        throw error;
    }
};
